export default __webpack_public_path__ + "static/media/background3.7ab52d10.jpg";